type CompetenceOwnership = {
  organisationId: number | null;
};

export function canEditCompetence(
  competence: CompetenceOwnership,
  generalRole: number | undefined
) {
  return competence.organisationId !== null || (generalRole || 0) >= 90;
}
